<template>
<div class="container-fluid" >

  <div class="card border-primary">
  <div class="card-header text-white bg-primary">
    <h4><i style="color:#FFD700" class="fas fa-shipping-fast mr-2" aria-hidden="true"></i>LISTA TRASFERIMENTI</h4>  
  </div> 

  <div>
    <div  class="card-body"> 
    <div class="row">
    <div v-if="type=='A'" class="col-4"> 
    <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
   <div class="card border-info" >
   <div class="card-header bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    
   
    <strong>PARAMETRI DI RICERCA</strong></div>
   <div class="card-body text-dark">

  <form name="movementSearch" v-on:submit.prevent="submit()">

        <label for="exampleFormControlSelect1"><strong>Provenienza</strong></label>
        <select @change="setStore($event,1)" required class="form-control" id="from_storeId" v-model="cerca.from_storeId">
            <option  value="-1"> -- TUTTE LE SEDI -- </option> 
            
            <option v-for="(item,index) in company.stores" :key="index" v-bind:value="item.storeId">
              {{item.store}}
            </option>
        </select>

          <label for="exampleFormControlSelect1"><strong>Destinazione</strong></label>
          <select @change="setStore($event,2)" required class="form-control" id="to_storeId" v-model="cerca.to_storeId">
            <option v-for="(item,index) in company.stores" :key="index" v-bind:value="item.storeId">
              {{item.store}}
            </option>
          </select>

    
        <label for="date_doc"><strong>da Data</strong></label>
        <input required v-model="cerca.from_create_at" type="date" class="form-control" placeholder="" >
        
        <label for="date_doc"><strong>a Data</strong></label>
        <input required v-model="cerca.to_create_at" type="date" class="form-control" placeholder="" >        
    

<div class="card-footer bg-transparent border-info mt-3"> 
   <button :disabled="spinner1" type="submit"   class="btn btn-primary float-right  ">
     <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
     CERCA
      <span v-if="spinner1" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
     </button>  

</div>              
  </form>

  </div>
</div>
</div>




<div v-else-if="type=='B'"  class="col">

  <button  @click="type='A'" type="button"   class="btn btn-secondary mt-1 ml-3">
<i style ="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
  ANNULLA
   
</button> 

<button  :disabled="items.length==0" @click="getAllMovements()" type="button"   class="btn btn-primary mt-1 ml-3">
<i class="fas fa-print mr-2" aria-hidden="true"></i>
  STAMPA CHECK LIST 
   <span v-if="spinner1" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
</button> 

  <div  class="table-wrapper-scroll-y my-custom-scrollbar mt-2">

<table  class="table table-hover table-bordered table-sm table-striped mb-0">
  <thead >
    <tr class="table-primary">
      <th scope="col">#</th>  
      <th scope="col">ID</th>  
      <th scope="col">DATA</th>
      <th scope="col">ORA</th>
      
      <th scope="col">PROVENIENZA</th>
      <th scope="col">DESTINAZIONE</th>
      <th class="text-right" scope="col">TOTALE</th>
      
      <th v-if="isAdmin!=0" class="text-right">VALORE</th>
      <th class="text-right">
        DDT
      </th>
      <th></th>
      
     
    </tr>
  </thead>
  <tbody>
    <tr  class="pointer" v-for="(item, index) in items" :key="index">
      <td>{{index+1}}</td>
      <td>{{item.stockMovementId}}</td>
      <td>{{item.create_at}} </td>
      <td>{{item.time_at}} </td>
      
      <td>{{item.store}}</td>
      <td>{{item.store_to}}</td>

      <td class="text-right">{{item.total_qty}} </td>
      <td v-if="isAdmin != 0" class="text-right">{{fmt1(item.total_price)}} </td>
      <td>
      
        <i v-if="item.rowId" style="color:brown" class="far fa-file-alt  float-right mr-1" aria-hidden="true">
         <h5> {{ item.number }} - {{ item.date }} </h5>
        </i>
      
      </td>
      
      <td>
      <div class="dropdown">
  <button style="color:black;background-color: white;" class="btn btn-info dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
    <i class="fas fa-cog mr-2" aria-hidden="true"></i>
    Opzioni
  </button>
  <div class="dropdown-menu ">
    <a class="dropdown-item" @click="setPackingSlip(item)" href="#">
      <i style="color:brown" class="far fa-file-alt mr-2" aria-hidden="true"></i>
      GENERA DDT</a>
    <a class="dropdown-item" @click="getProductData(1,item)" href="#">
      <i style="color:darkgreen" class="fas fa-print mr-2" aria-hidden="true"></i>
      STAMPA CHECK LIST </a>
      <a class="dropdown-item" @click="setMatching(item.stockMovementId)" href="#">
      <i style="color:crimson" class="far fa-check-square mr-2" aria-hidden="true"></i>
      MATCHING PRODOTTI </a>

    <!--<a class="dropdown-item" @click="getProductData(2,item)" href="#">CHECK LIST SINTETICA</a>-->
  </div>
</div>
     </td>
    </tr> 
  </tbody>
     <tfoot>
      <tr> 
      <td></td>        
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>        
              
      <td class="text-right">  {{total.qty}}</td>
      <td  v-if="isAdmin != 0" class="text-right">€ {{fmt1(total.total)}}</td>
      <td></td>    
      <td></td>   
      
      </tr>   
  </tfoot>    


</table>


</div>



<!--


  <div  class="table-wrapper-scroll-y my-custom-scrollbar mt-2">

  <table  class="table table-hover table-striped mb-0">
    <thead >
      <tr class="table-primary">
        <th scope="col">#</th>  
        <th scope="col">ID</th>  
        <th scope="col">DATA</th>
        <th scope="col">ORA</th>
        
        <th scope="col">ID PRODOTTO</th>
        <th scope="col">CODICE ARTICOLO</th>
        <th scope="col">BRAND</th>
        <th scope="col">CATEGORIA</th>
        <th scope="col">COLORE</th>
        <th scope="col">MISURA</th>
        
        <th scope="col">REPARTO</th>
        <th scope="col">STAGIONE</th>
        <th class="text-right" scope="col">Q.TA'</th>

        <th v-if="isAdmin!=0" class="text-right">VALORE</th>
       
      </tr>
    </thead>
    <tbody>
      <tr @dblclick="setPackingSlip(item)" data-toggle="tooltip" title="doppio click stampa DDT" class="pointer" v-for="(item, index) in items" :key="index">
        <td>{{index+1}}</td>
        <td>{{item.stockMovementId}}</td>
        <td>{{item.create_at}} </td>
        <td>{{item.time_at}} </td>
        
        <td>{{item.productId}}</td>
        <td>{{item.sku}}
          
        </td>
        <td>{{item.brand}}</td>
        <td>{{item.category}}</td>
        <td>{{item.color}}</td>
        <td>{{item.size}}</td>
        <td>{{item.department}}</td>
        <td>{{item.season}} - {{item.season_year}} </td>
        <td class="text-right">{{item.qty}} </td>
        <td v-if="isAdmin != 0" class="text-right">{{fmt1(item.price)}} </td>
       
      </tr> 
    </tbody>
       <tfoot>
        <tr> 
        <td></td>        
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>        
        <td></td>
        <td></td>
                
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="text-right">  {{total.qty}}</td>
        <td  v-if="isAdmin != 0" class="text-right">€ {{fmt1(total.total)}}</td>
            
               
        </tr>   
    </tfoot>    


  </table>


</div>

-->





</div>


<div v-else-if="type=='C'" class="col-md-12">
  <matching v-if="stockMovementId" v-bind:stockMovementId="stockMovementId" @close="stockMovementId=0,type='B'"></matching>
</div>

<div v-else class="col">
  <packing-slip @close="type='B'" v-bind:params="params"></packing-slip>
</div>

</div>  
</div>  
</div>
<div>

</div>


<!-- ROW -->
</div>
<!-- CARD  -->

</div>
</template>
<script>
import master            from '@/components/frontOffice/StoresMovementMaster.vue'
import jsPDF             from 'jspdf';

import api               from '@/api'  
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import {setFmtDate1}      from '@/functions';   
import PackingSlip       from '@/components/shipping/PackingSlipStoreToStore.vue'
import matching          from '@/components/frontOffice/StoreStockMovementMatching.vue'

import fmt               from '@/components/mixins/fmt.js'




export default {
  mixins: [fmt],
  
  components: {alertBox,master,PackingSlip,matching},
  data() {
    return {
      

      type            : 'A',
      params          : {movementId : 0,total_qty : 0,data_mov:'',time_at:''},
      
      
      store           : {store1:'TUTTE LE SEDI'},
      description1    : '',
      description2    : '',
     
      option           : 1,
      cerca            : {
        from_create_at : new Date().toISOString().slice(0, 10),
        to_create_at   : new Date().toISOString().slice(0, 10)},
     
      spinner1        : false,
      spinner2        : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      items           : [],
      pdf_items       : [],
      stockMovementId : 0
      
      
    };
  },

  computed :{
    ...mapGetters(['company','isAdmin','storeId']),
    total : function()  {

      let _total = 0
      let _qty = 0
      
      this.items.forEach(item =>
        {
          
          _total += Number(item.total_price)
          _qty += Number(item.total_qty)
        }
      )
      let total = {'total':_total,'qty':_qty}
      return total
    }
   
  },


  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {
    
    this.cerca.from_storeId = this.storeId
    this.cerca.from_storeId = -1
  },
  methods: {
   
   setMatching(stockMovementId)
   {
    
    this.stockMovementId = stockMovementId
   
    this.type = 'C'
   }, 
   setStore(e,store) 
   {
    
    if(store == 1)
    {
     this.store.store1 = e.target.options[e.target.options.selectedIndex].text  
      
    }

    if(store == 2)
    {
      
      this.store.store2 = e.target.options[e.target.options.selectedIndex].text  
    }

    this.description1 = 'da   ' + this.store.store1 + '   a   ' + this.store.store2
    
   },
   setPackingSlip(item)
   {
     

     let total_qty = 0
     
     if(item.stockMovementId)
     {
        this.items.forEach(row =>
        { 
          if(item.stockMovementId == row.stockMovementId  )    
          total_qty += Number(row.total_qty)
        })

        this.params.movementId      = item.stockMovementId
        this.params.data_mov        = item.create_at
        this.params.time_at         = item.time_at
        this.params.total_qty       = total_qty
        this.params.store           = item.store
        this.params.store_to        = item.store_to  
        this.params.storeId         = item.storeId


        //this.stockMovementId = stockMovementId
        this.type = 'D'

     }

   }, 

    
  
    printPDF()
    {
      const doc = new jsPDF()

      this.spinner2 = true  
      var page = 1
      
      var pages = parseInt(this.pdf_items.length / 50) == this.pdf_items.length / 50 ? parseInt(this.pdf_items.length / 50) : parseInt(this.pdf_items.length / 50) + 1
      
      var row_index = 1
      var page_index = 1
      var init_row = 31
      var row = init_row
      var row_header = row -5
      var col = 10
      var col1 = 20
      var col2 = 50
      var col3 = 90
      var col4 = 150
      var col5 = 171
      var total = 0
      //var doc = new jsPDF()

      var header = function(description1,description2)
      {
        var d = new Date();
        var n = d.toLocaleString();
        doc.setFontSize(12)
        doc.text('CHECK LIST TRASFERIMENTO ',  105, 10, null, null, "center");
        doc.setTextColor(0, 0, 255);
        doc.text(description1,  105, 15, null, null, "center");
        doc.setTextColor(0, 0, 0);
        doc.text(description2,  105, 20, null, null, "center");
        doc.setFont("helvetica","bold");
      
        doc.setFontSize(10)
      
        doc.text('BRAND', col1,row_header);
        doc.text('CATEGORIA', col2, row_header);
        doc.text('PRODOTTO', col3, row_header);
        doc.text('COLORE', col4, row_header);
        doc.text('MIS.', col5, row_header);

        doc.text('Q.TA', 200, row_header,null,null,'right');
        doc.setFont("helvetica","normal");

      }
      var footer = function()
      {
        doc.setFontSize(8)
        doc.text('pag. ' + page.toString() + ' / ' + pages.toString(),  105, 290, null, null, "center");
       
      }
      
      header(this.description1,this.description2)
      footer()


      this.pdf_items.forEach(item=>{
        if(item.row_type == 1)
        {
          total += Number(item.qty)
        }
                       
        doc.setFontSize(8)       
        doc.text(row_index.toString(), col, row);
        if(item.category.substr(0,10) == 'Tot. Brand')
        {
          
          doc.setTextColor(14, 161, 0);     
          
          doc.setFont("helvetica","bold");   
          
          
          //doc.setFontSize(10)
        }
        doc.text(item.brand.toString().substr(0,15), col1, row);
        
        
        if(item.sku.length == 0 && item.category.substr(0,10) != 'Tot. Brand')
        {
          
          doc.setFont("helvetica","bold"); 
                   
        }
       
       doc.text(item.category.toString().substr(0,20), col2, row);
       doc.setFont("helvetica","normal"); 
       doc.text(item.sku.toString().substr(0,50), col3, row);
       doc.text(item.color.toString().substr(0,10), col4, row);
       doc.text(item.size.toString().substr(0,5), col5, row);

       doc.text(item.qty.toString(), 200, row,null,null,'right');
       doc.setTextColor(0, 0, 0);    
        if(item.sku.length == 0 && item.category.substr(0,10) != 'Tot. Brand')
        {
          
          
          doc.rect(col+175, row-3, 19, 4)
          
          //doc.setFontSize(10)
        }


        if(item.category.substr(0,10) == 'Tot. Brand')
        {
          
                
          doc.roundedRect(col + 9, row - 3, 185, 4,2,2)
          
          //doc.setFontSize(10)
        }

        if(page_index == 50 && row_index < this.pdf_items.length)
        {
          page++  
          doc.addPage("a4");
          header(this.description1,this.description2)
          footer()
          row = init_row
          row_index++
          page_index = 1
        }
        else
        {
          row = row + 5
          row_index++
          page_index++
        }
        
      })
        doc.setFontSize(10)
        doc.text('TOTALE ' + total ,  200, 285, null, null, "right");
      //doc.save('CheckList_' + Date.now().toString() )
      let fileName = 'CheckList_' + Date.now().toString()
      window.open(doc.output('bloburl', { filename: fileName }), '_blank');
      this.spinner2 = false
    },
    submit() 
    {
      
      this.msg.title = '' 
      if(this.cerca.from_storeId == this.cerca.to_storeId)
      {
        
        

        this.msg.title = 'ATTENZIONE '
        this.msg.body  = 'Provenienza e Destinazione devono essere diversi.'
        this.msg.type  = 1

        
        return
      }
      this.getData()
    },  
    
    
     async  getProductData(option,item) {

      //this.items = []
      
      this.msg.title = '' 
      var sp = {'sp' : option == 1 ? 'spProductMovementStoreToStore':'spProductMovementStoreToStoreGrouped'}
           
      var data  = {
      'from_storeId'   : this.cerca.from_storeId,
      'to_storeId'     : this.cerca.to_storeId,
      'from_create_at' : this.cerca.from_create_at,
      'to_create_at'   : this.cerca.to_create_at,
      'movementId'     : item.stockMovementId
      }
     
      var json  = Object.assign(data, sp)
      this.spinner1 = true
      await api.post(json).then(res => {
        if(res.status==200)
          {
           
            this.pdf_items = res.data.recordsets[1] 
            this.description1 = 'da   ' + item.store + '   a   ' + item.store_to          
            this.description2 = 'del ' + item.create_at           
            this.printPDF()  
            
          }
          else if(res.status==500)
          {
            

            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res.data
            this.msg.type  = 1

          } 
          else
          {
            

            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1

          } 
      }).catch(err => 
      {
        
        this.msg.title = 'ATTENZIONE '
        this.msg.body  = err.message
        this.msg.type  = 1                
        
      }).finally(() => {
        this.spinner1 = false
      });




    }
,

async  getData() 
{

this.items = []

this.msg.title = '' 
const sp = {'sp' : 'spMovementStoreToStore'}
     
const data  = {
'from_storeId'   : this.cerca.from_storeId,
'to_storeId'     : this.cerca.to_storeId,
'from_create_at' : this.cerca.from_create_at,
'to_create_at'   : this.cerca.to_create_at
}

const json  = Object.assign(data, sp)
this.spinner1 = true
await api.post(json).then(res => {
  if(res.status==200)
    {
      this.items = res.data.recordsets[0]

      
      if(this.items.length==0)
        {

          

          this.msg.title = 'ATTENZIONE '
          this.msg.body  = 'Movimenti di trasferimento non trovati.'
          this.msg.type  = 1
          
        }         
        else
        {
          this.description1 = 'da   ' + this.items[0].store + '   a   ' + this.items[0].store_to
          this.type = 'B'
        }
    }
    else if(res.status==500)
    {
      

      this.msg.title = 'ATTENZIONE '
      this.msg.body  = res.data
      this.msg.type  = 1

    } 
    else
    {
      

      this.msg.title = 'ATTENZIONE '
      this.msg.body  = res
      this.msg.type  = 1

    } 
}).catch(err => 
{
  
  this.msg.title = 'ATTENZIONE '
  this.msg.body  = err.message
  this.msg.type  = 1                
  
}).finally(() => {
  this.spinner1 = false
});




},

async  getAllMovements() {

const data1  = setFmtDate1(this.cerca.from_create_at)
const data2  = setFmtDate1(this.cerca.to_create_at)

this.description1 = 'da ' +  this.store.store1 + '   a   ' + this.store.store2          
this.description2 = 'dal   ' + data1 + '   al   ' + data2

this.msg.title = '' 
const sp = {'sp' : 'spAllMovementsStoreToStorePDF'}
     
const data  = {
  'body'           : this.items
}

const json  = Object.assign(data, sp)
this.spinner1 = true
await api.post(json).then(res => {
  if(res.status==200)
    {
      
      this.pdf_items = res.data.recordsets[0]
      
      this.printPDF()
      
      
    }
    else if(res.status==500)
    {
      

      this.msg.title = 'ATTENZIONE '
      this.msg.body  = res.data
      this.msg.type  = 1

    } 
    else
    {
      

      this.msg.title = 'ATTENZIONE '
      this.msg.body  = res
      this.msg.type  = 1

    } 
}).catch(err => 
{
  
  this.msg.title = 'ATTENZIONE '
  this.msg.body  = err.message
  this.msg.type  = 1                
  
}).finally(() => {
  this.spinner1 = false
});




}



  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position: relative;
height: 500px;
overflow: auto;
}
.pointer:hover
{
  _background-color: blue;
  _color: white;
  cursor: pointer;
}
.table-wrapper-scroll-y {
display: block;
}
h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
h5 {
  font-family  : 'Roboto Condensed';
  font-size    : 16px;
}
.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #5c8fb1;
    color        : black;
    position     : sticky;
    top          : 0;
    z-index      : 10;
    height       : 40px;

 }
 .table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-weight  : bold;
    font-size    : 20px;
    background   : whitesmoke;
    color        : green;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

 .card-header
{
  height: 45px;
}
.table,
.table th, 
.table td
{
  border-color: #3b28a7 !important;
}
.table {
  border-collapse: separate;
}
</style>